import {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cilBadge,
  cilLightbulb,
  cilBriefcase,
  cilLaptop,
  cilFolderOpen,
  cil3d,
  cilAccountLogout,
  cilAirplay,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilApps,
  cilArrowBottom,
  cilArrowCircleBottom,
  cilArrowRight,
  cilArrowTop,
  cilArrowThickTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBolt,
  cilBook,
  cilBookmark,
  cilBorderAll,
  cilBuilding,
  cilCalculator,
  cilCalendarCheck,
  cilCalendar,
  cilCart,
  cilChart,
  cilChartLine,
  cilChartPie,
  cilChatBubble,
  cilCheck,
  cilCheckAlt,
  cilCheckCircle,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCode,
  cilCommentSquare,
  cilCash,
  cilCompass,
  cilContrast,
  cilCreditCard,
  cilCursor,
  cilDataTransferDown,
  cilDescription,
  cilDevices,
  cilDollar,
  cilDrop,
  cilEco,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilExpandRight,
  cilExternalLink,
  cilFile,
  cilFolder,
  cilGraph,
  cilGrid,
  cilGlobeAlt,
  cilGroup,
  cilHandshake,
  cilHistory,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInfo,
  cilImage,
  cilItalic,
  cilJustifyCenter,
  cilLanguage,
  cilLayers,
  cilList,
  cilListNumbered,
  cilLineSpacing,
  cilLocationPin,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMediaPause,
  cilMediaStop,
  cilMediaRecord,
  cilMenu,
  cilMinus,
  cilMoney,
  cilMoodBad,
  cilMoon,
  cilNotes,
  cilObjectGroup,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPin,
  cilPeople,
  cilPlus,
  cilPrint,
  cilReload,
  cilPuzzle,
  cilReportSlash,
  cilRouter,
  cilSave,
  cilSearch,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilSpeech,
  cilSpaceBar,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTablet,
  cilTags,
  cilTask,
  cilTerminal,
  cilTrash,
  cilTruck,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilVerticalAlignBottom,
  cilVerticalAlignCenter,
  cilVerticalAlignTop,
  cilWallet,
  cilX,
  cilXCircle,
  cilZoom
} from '@coreui/icons';

import { signet } from './signet';
import { logo } from './logo';

export const iconSubset = {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cilBadge,
  cilLightbulb,
  cilBriefcase,
  cilLaptop,
  cilFolderOpen,
  cil3d,
  cilAccountLogout,
  cilAirplay,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilApps,
  cilArrowBottom,
  cilArrowCircleBottom,
  cilArrowRight,
  cilArrowTop,
  cilArrowThickTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBolt,
  cilBook,
  cilBookmark,
  cilBorderAll,
  cilBuilding,
  cilCart,
  cilCash,
  cilCalculator,
  cilCalendarCheck,
  cilCalendar,
  cilChart,
  cilChartLine,
  cilChartPie,
  cilChatBubble,
  cilCheck,
  cilCheckAlt,
  cilCheckCircle,
  cilChevronLeft,
  cilChevronRight,
  cilCloudDownload,
  cilCode,
  cilCommentSquare,
  cilCompass,
  cilContrast,
  cilCreditCard,
  cilCursor,
  cilDataTransferDown,
  cilDescription,
  cilDevices,
  cilDollar,
  cilDrop,
  cilEco,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilExpandRight,
  cilExternalLink,
  cilFile,
  cilFolder,
  cilGraph,
  cilGrid,
  cilGlobeAlt,
  cilGroup,
  cilHandshake,
  cilHistory,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilInfo,
  cilImage,
  cilItalic,
  cilJustifyCenter,
  cilLanguage,
  cilLayers,
  cilList,
  cilListNumbered,
  cilLineSpacing,
  cilLocationPin,
  cilLockLocked,
  cilLockUnlocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMediaPause,
  cilMediaStop,
  cilMediaRecord,
  cilMenu,
  cilMinus,
  cilMoodBad,
  cilMoney,
  cilMoon,
  cilNotes,
  cilObjectGroup,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPin,
  cilPeople,
  cilPlus,
  cilPrint,
  cilReload,
  cilPuzzle,
  cilReportSlash,
  cilRouter,
  cilSave,
  cilSearch,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilSpeech,
  cilSpaceBar,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTablet,
  cilTags,
  cilTask,
  cilTerminal,
  cilTrash,
  cilTruck,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilVerticalAlignBottom,
  cilVerticalAlignCenter,
  cilVerticalAlignTop,
  cilWallet,
  cilX,
  cilXCircle,
  cilZoom,
  logo,
  signet
};

export enum IconSubset {
  cibCcAmex = 'cibCcAmex',
  cibCcApplePay = 'cibCcApplePay',
  cibCcMastercard = 'cibCcMastercard',
  cibCcPaypal = 'cibCcPaypal',
  cibCcStripe = 'cibCcStripe',
  cibCcVisa = 'cibCcVisa',
  cibFacebook = 'cibFacebook',
  cibGoogle = 'cibGoogle',
  cibLinkedin = 'cibLinkedin',
  cibSkype = 'cibSkype',
  cibTwitter = 'cibTwitter',
  cifBr = 'cifBr',
  cifEs = 'cifEs',
  cifFr = 'cifFr',
  cifIn = 'cifIn',
  cifPl = 'cifPl',
  cifUs = 'cifUs',
  cilBadge = 'cilBadge',
  cilLightbulb = 'cilLightbulb',
  cilBriefcase = 'cilBriefcase',
  cilLaptop = 'cilLaptop',
  cilFolderOpen = 'cilFolderOpen',
  cil3d = 'cil3d',
  cilAccountLogout = 'cilAccountLogout',
  cilAirplay = 'cilAirplay',
  cilAlignCenter = 'cilAlignCenter',
  cilAlignLeft = 'cilAlignLeft',
  cilAlignRight = 'cilAlignRight',
  cilBorderAll = 'cilBorderAll',
  cilApps = 'cilApps',
  cilApplicationsSettings = 'cilApplicationsSettings',
  cilArrowCircleBottom = 'cilArrowCircleBottom',
  cilArrowBottom = 'cilArrowBottom',
  cilArrowRight = 'cilArrowRight',
  cilArrowTop = 'cilArrowTop',
  cilArrowThickTop = 'cilArrowThickTop',
  cilBasket = 'cilBasket',
  cilBell = 'cilBell',
  cilBold = 'cilBold',
  cilBolt = 'cilBolt',
  cilBook = 'cilBook',
  cilBookmark = 'cilBookmark',
  cilBuilding = 'cilBuilding',
  cilCart = 'cilCart',
  cilCash = 'cilCash',
  cilCalculator = 'cilCalculator',
  cilCalendarCheck = '  cilCalendarCheck,',
  cilCalendar = 'cilCalendar',
  cilChart = 'cilChart',
  cilChartLine = 'cilChartLine',
  cilChartPie = 'cilChartPie',
  cilChatBubble = 'cilChatBubble',
  cilCheck = 'cilCheck',
  cilCheckAlt = 'cilCheckAlt',
  cilCheckCircle = 'cilCheckCircle',
  cilChevronLeft = 'cilChevronLeft',
  cilChevronRight = 'cilChevronRight',
  cilCloudDownload = 'cilCloudDownload',
  cilCode = 'cilCode',
  cilCommentSquare = 'cilCommentSquare',
  cilCompass = 'cilCompass',
  cilContrast = 'cilContrast',
  cilCreditCard = 'cilCreditCard',
  cilCursor = 'cilCursor',
  cilDataTransferDown = 'cilDataTransferDown',
  cilDescription = 'cilDescription',
  cilDevices = 'cilDevices',
  cilDollar = 'cilDollar',
  cilDrop = 'cilDrop',
  cilEco = 'cilEco',
  cilEnvelopeClosed = 'cilEnvelopeClosed',
  cilEnvelopeOpen = 'cilEnvelopeOpen',
  cilExpandRight = 'cilExpandRight',
  cilFile = 'cilFile',
  cilFolder = 'cilFolder',
  cilGrid = 'cilGrid',
  cilGlobeAlt = 'cilGlobeAlt',
  cilGraph = 'cilGraph',
  cilGroup = 'cilGroup',
  cilHandshake = 'cilHandshake',
  cilHistory = 'cilHistory',
  cilHome = 'cilHome',
  cilInbox = 'cilInbox',
  cilIndentDecrease = 'cilIndentDecrease',
  cilIndentIncrease = 'cilIndentIncrease',
  cilInfo = 'cilInfo',
  cilImage = 'cilImage',
  cilItalic = 'cilItalic',
  cilJustifyCenter = 'cilJustifyCenter',
  cilLanguage = 'cilLanguage',
  cilLayers = 'cilLayers',
  cilList = 'cilList',
  cilListNumbered = 'cilListNumbered',
  cilLineSpacing = 'cilLineSpacing',
  cilLocationPin = 'cilLocationPin',
  cilLockLocked = 'cilLockLocked',
  cilLockUnlocked = 'cilLockUnlocked',
  cilMagnifyingGlass = 'cilMagnifyingGlass',
  cilMap = 'cilMap',
  cilMediaPlay = 'cilMediaPlay',
  cilMediaPause = 'cilMediaPause',
  cilMediaStop = 'cilMediaStop',
  cilMediaRecord = 'cilMediaRecord',
  cilMenu = 'cilMenu',
  cilMinus = 'cilMinus',
  cilMoodBad = 'cilMoodBad',
  cilMoney = 'cilMoney',
  cilMoon = 'cilMoon',
  cilNotes = 'cilNotes',
  cilObjectGroup = 'cilObjectGroup',
  cilOptions = 'cilOptions',
  cilPaperclip = 'cilPaperclip',
  cilPaperPlane = 'cilPaperPlane',
  cilPen = 'cilPen',
  cilPencil = 'cilPencil',
  cilPin = 'cilPin',
  cilPeople = 'cilPeople',
  cilPlus = 'cilPlus',
  cilPrint = 'cilPrint',
  cilPuzzle = 'cilPuzzle',
  cilReportSlash = 'cilReportSlash',
  cilRouter = 'cilRouter',
  cilSave = 'cilSave',
  cilSettings = 'cilSettings',
  cilShare = 'cilShare',
  cilShareAll = 'cilShareAll',
  cilShareBoxed = 'cilShareBoxed',
  cilSearch = 'cilSearch',
  cilSpeech = 'cilSpeech',
  cilSpaceBar = 'cilSpaceBar',
  cilSpeedometer = 'cilSpeedometer',
  cilSpreadsheet = 'cilSpreadsheet',
  cilStar = 'cilStar',
  cilSun = 'cilSun',
  cilTablet = 'cilTablet',
  cilTags = 'cilTags',
  cilTask = 'cilTask',
  cilTerminal = 'cilTerminal',
  cilTrash = 'cilTrash',
  cilTruck = 'cilTruck',
  cilUnderline = 'cilUnderline',
  cilUser = 'cilUser',
  cilUserFemale = 'cilUserFemale',
  cilUserFollow = 'cilUserFollow',
  cilUserUnfollow = 'cilUserUnfollow',
  cilVerticalAlignBottom = 'cilVerticalAlignBottom',
  cilVerticalAlignCenter = 'cilVerticalAlignCenter',
  cilVerticalAlignTop = 'cilVerticalAlignTop',
  cilWallet = 'cilWallet',
  cilX = 'cilX',
  cilXCircle = 'cilXCircle',
  cilZoom = 'cilZoom',
  logo = 'logo',
  signet = 'signet'
}

